import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPdf = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 56 56'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g filter='url(#pdf_svg__a)' fill='#fff'>
      <path
        fill='#fff'
        d='M16 48h24a4 4 0 0 0 4-4V20L32 8H16a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4'
      />
      <path
        stroke='#D44949'
        d='M16 8.5h15.793L43.5 20.207V44a3.5 3.5 0 0 1-3.5 3.5H16a3.5 3.5 0 0 1-3.5-3.5V12A3.5 3.5 0 0 1 16 8.5Z'
      />
    </g>
    <path fill='url(#pdf_svg__b)' d='M44 20v8l-8-8h-4V8z' />
    <path fill='url(#pdf_svg__c)' d='M44 20H32V8z' />
    <path
      fill='#CD2828'
      d='M21.599 35.26q.852 0 1.44.3.6.288.912.864.312.564.312 1.38 0 .828-.312 1.392a2.07 2.07 0 0 1-.912.864q-.588.288-1.44.288h-1.56V39.04h1.428q.444 0 .708-.12a.8.8 0 0 0 .384-.396q.12-.264.12-.72 0-.444-.12-.708a.74.74 0 0 0-.384-.396q-.264-.12-.708-.12h-1.248V43h-1.584v-7.74zm6.473 0q1.104 0 1.872.408t1.164 1.2q.396.78.396 1.92v.696q0 1.14-.396 1.932-.396.78-1.164 1.188-.768.396-1.872.396h-2.664v-7.74zm-.108 6.432q.672 0 1.104-.228t.636-.708q.216-.48.216-1.224v-.804q0-.744-.216-1.212a1.38 1.38 0 0 0-.636-.708q-.432-.228-1.104-.228h-.972v5.112zm9.878-6.432v1.332h-3.42V43h-1.584v-7.74zm-.468 3.468v1.308H34.23v-1.308z'
    />
    <defs>
      <linearGradient
        id='pdf_svg__b'
        x1={40}
        x2={40}
        y1={8}
        y2={36}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#CD2828' stopOpacity={0.502} />
        <stop offset={1} stopColor='#CD2828' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='pdf_svg__c'
        x1={38}
        x2={38}
        y1={8}
        y2={20}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#CD2828' stopOpacity={0} />
        <stop offset={1} stopColor='#CD2828' />
      </linearGradient>
      <filter
        id='pdf_svg__a'
        width={44}
        height={52}
        x={6}
        y={4}
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values='0 0 0 0 0.803922 0 0 0 0 0.156863 0 0 0 0 0.156863 0 0 0 0.16 0' />
        <feBlend
          in2='BackgroundImageFix'
          result='effect1_dropShadow_12188_28847'
        />
        <feBlend
          in='SourceGraphic'
          in2='effect1_dropShadow_12188_28847'
          result='shape'
        />
      </filter>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgPdf)
export default ForwardRef
